<div id="header">
    <img id="logo" src="/images/logo-full.png" class="logo">
    <button class="button menu"></button>
</div>